import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { Container } from '../layout/Container'
import { Button } from '../ui/Button'
import { ArrowRight, Play } from 'lucide-react'
import { HeroMockupCarousel } from './HeroMockupCarousel'

export function Hero() {
  const { t } = useTranslation()

  return (
    <section className="relative flex min-h-screen items-center overflow-hidden pt-16">
      <div className="absolute inset-0 bg-grid" />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-bg/50 to-bg" />

      <Container size="narrow" className="relative z-10 py-20 text-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="inline-flex items-center gap-2 rounded-full border border-accent/30 bg-accent/10 px-4 py-1.5 text-xs font-medium text-accent-light"
        >
          {t('hero.badge')}
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="mt-8 text-4xl font-semibold tracking-tight text-text-primary sm:text-5xl md:text-6xl lg:text-7xl"
        >
          {t('hero.headline')}
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mx-auto mt-6 max-w-2xl text-lg text-text-secondary md:text-xl"
        >
          {t('hero.subheadline')}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row"
        >
          <Button asChild size="lg">
            <a href="#diagnostico" className="group">
              {t('hero.ctaPrimary')}
              <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
            </a>
          </Button>
          <Button asChild variant="outline" size="lg">
            <a href="#sistema" className="group">
              <Play className="mr-2 h-4 w-4" />
              {t('hero.ctaSecondary')}
            </a>
          </Button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          className="relative mx-auto mt-16 max-w-4xl"
        >
          <div className="absolute -inset-1 rounded-2xl bg-gradient-to-r from-accent/20 to-accent-light/20 blur-xl" />
          <div className="relative overflow-hidden rounded-2xl border border-border-subtle bg-surface-elevated p-2">
            <div className="aspect-[16/9] rounded-xl">
              <HeroMockupCarousel />
            </div>
          </div>
        </motion.div>
      </Container>
    </section>
  )
}
